require('./new-salon.scss')

module.exports = {
  template: require('./new-salon.pug')()
  controller: require('./new-salon.ctrl')
}
